export const priorityTable = {
  "(": -2,
  "{": -2,

  ")": -1,
  "}": -1,

  ";": 0,

  log: 1,

  "||": 2,
  "&&": 3,

  "!": 4,

  ">": 5,
  ">=": 5,
  "<": 5,
  "<=": 5,

  "==": 5,
  "!=": 5,
  "===": 5,
  "!==": 5,

  "=": 6,
  "+=": 6,
  "-=": 6,
  "*=": 6,
  "/=": 6,
  "^=": 6,
  "%=": 6,

  "+": 7,
  "-": 7,

  "*": 8,
  "/": 8,
  "^": 8,
  "%": 8,

  $UPlus: 9,
  $UMinus: 9,

  var: 9,
  let: 9,
  const: 9,
};
